<template>
  <div class="cart-header">
    <div class="container">
      <h1 class="cart-header__title">
        {{ $t("services.cart.pageTitle") }}
      </h1>

      <div class="cart-header__bottom">
        <BreadCrumbs :links="breadcrumbs" />

        <div class="cart__header-dropdown">
          <span class="cart__header-dropdown-title">
            {{ $t("services.currencyTitle") }}:
          </span>
          <Dropdown
            :value="currentCurrencies"
            single
            modified
            title="₽"
            label-name="symbol"
            key-name="code"
            class="cart__header-dropdown-select cart__header-currency"
            @select="setCurrency"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BreadCrumbs, Dropdown } from "@v2/shared/ui/components";
import { mapGetters } from "vuex";

export default {
  name: "CartHeader",
  components: { Dropdown, BreadCrumbs },
  props: {
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters("event", ["eventCurrencies", "currency", "stands"]),
    currentCurrencies() {
      return this.eventCurrencies.map(currency => {
        return { ...currency, selected: currency.code === this.currency?.code };
      });
    },
    currentStands() {
      return this.stands.map(stand => {
        return { ...stand, selected: stand.id === this.currentStand?.id };
      });
    }
  },
  methods: {
    setCurrency(currency) {
      if (currency) {
        this.$store.dispatch("event/setCurrency", currency.code);
      }
    }
  }
};
</script>

<style lang="scss">
.cart-header {
  background: var(--white, #fff);
  border-bottom: 1px solid var(--gray-darker, #d5dae5);
  padding: 30px 0;
  position: relative;
  z-index: 6;
  @media (max-width: 440px) {
    padding: 15px 0;
  }

  &__title {
    color: var(--dark, #262626);
    font-size: 2.125rem;
    font-weight: 700;
    line-height: normal;
    margin: 0 0 40px 0;

    @media (max-width: 440px) {
      font-size: 1rem;
      font-weight: 700;
      line-height: 24px;
      margin: 0 0 15px 0;
    }
  }

  &__bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }
}

.cart__header-dropdown {
  display: flex;
  align-items: center;
  margin-left: auto;

  @media (max-width: 768px) {
    margin-left: 0;
    margin-top: 15px;
  }

  &-title {
    color: var(--dark-light, #6d7179);
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 22px;
    margin-right: 5px;
    margin-left: 30px;

    @media (max-width: 768px) {
      margin-left: 0;
    }
  }

  &-select {
    height: 40px;

    .dropdown__header {
      height: 40px;
      background: var(--gray, #f9f9f9);
      border: none;
      min-width: 50px;
      padding: 0 10px;
      transition: var(--transition);

      @media (max-width: 740px) {
        height: 40px;
        width: auto;
        margin: 0;
      }

      &:hover {
        background: var(--gray-2, #eaeaea);
      }

      .svg-icon {
        margin-left: 3px;
        color: var(--dark-light, #6d7179);
        width: 12px;
        height: 12px;
      }
    }

    .dropdown__header-text {
      color: var(--dark, #262626);
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
    }
  }
}

.cart__header-currency {
  .dropdown__content {
    right: 0;
    left: auto;
    width: 50px;

    &-item {
      text-align: center;
    }
  }
}
</style>
